import { env } from "next-runtime-env";

const NEXT_PUBLIC_API_URL = env('NEXT_PUBLIC_API_URL');
const NEXT_PUBLIC_BASE_PATH = env('NEXT_PUBLIC_BASE_PATH');
const NEXT_PUBLIC_TURNSTILE_SITE_KEY = env('NEXT_PUBLIC_TURNSTILE_SITE_KEY');

type Config = {
  basePath: string;
  apiUrl: string;
  turnstile_key: string;
}
/**
 * 
 * Configuração base path configurando no .env
 * 
 */

export const config: Config = {
  basePath: NEXT_PUBLIC_BASE_PATH || '',
  apiUrl: NEXT_PUBLIC_API_URL || 'http://localhost:3333',
  turnstile_key: NEXT_PUBLIC_TURNSTILE_SITE_KEY || ""
}